import { z } from 'zod'

/** 區域 Schema */
export const areaSchema = z.object({
  code: z.string(),
  name: z.string(),
  enable: z.boolean()
})

/** 區域 */
export interface Area extends z.infer<typeof areaSchema> {}
